import angular from 'angular';
import commissionFilterModal from './commissionFilterModal';
import './style.scss';

export default angular
  .module('commission.components.commissionFilterModal', [])
  .component('commissionFilterModal', commissionFilterModal).name;
